import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReadWriteDirective } from './read-write.directive';



@NgModule({
  declarations: [ReadWriteDirective],
  imports: [
    CommonModule,
  ],
  exports: [
    ReadWriteDirective
  ]
})
export class ReadWriteModule { }
